export default __webpack_public_path__ + "static/media/crypto-prices.a21e2e22.svg";